module.exports = __webpack_public_path__ + "static/media/refugee2.21af5995.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/refugee/refugee2.png
// module id = 121
// module chunks = 0